// Student-specific component styles built on the shared mockup palette.
import { BLUE, BLUE_PRESSED, BORDER, ERROR, INK, INTER, PAGE_BACKGROUND, YELLOW, YELLOW_HOVER } from '../../mockupPalette';

export * from '../../mockupPalette';

export const RING_TRACK = BORDER;
export const RED = ERROR;
export const SURFACE_SOFT = PAGE_BACKGROUND;

export const cardSx = {
    backgroundColor: '#fff',
    border: `1px solid ${RING_TRACK}`,
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(22, 58, 99, 0.08)',
};

export const yellowButtonSx = {
    fontFamily: INTER,
    fontWeight: 700,
    fontSize: '16px',
    minHeight: '44px',
    borderRadius: '11px',
    px: 3,
    py: 1.5,
    backgroundColor: YELLOW,
    color: INK,
    boxShadow: 'none',
    textTransform: 'none' as const,
    '&:hover': {
        backgroundColor: YELLOW_HOVER,
        boxShadow: 'none',
    },
};

export const blueButtonSx = {
    fontFamily: INTER,
    fontWeight: 700,
    fontSize: '15px',
    minHeight: '44px',
    borderRadius: '11px',
    px: 3,
    py: 1.5,
    backgroundColor: BLUE,
    color: '#FFFFFF',
    boxShadow: 'none',
    textTransform: 'none' as const,
    '&:hover': {
        backgroundColor: BLUE_PRESSED,
        boxShadow: 'none',
    },
};
